
import Urls from "./url"
const bearer_token='eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2NDc2MDEyODIsImV4cCI6MTY0NzYwNDg4MiwiZW1haWwiOiJ0ZXN0ZXJAdXNlci5jaCIsImlkIjoyLCJzaXRlIjoiaHR0cDpcL1wvbG9jYWxob3N0OjgwODAiLCJ1c2VybmFtZSI6InRlc3RVc2VyIn0.b_Vyr9HQPBkwcdSU59gw0sNPB0wR6RcjlzQWjimyjz0';
const bearer ='Bearer '+ bearer_token;
const options = {
    method: 'GET',
    headers: {
        'Authorization': bearer,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json'
    }
}

export const fetchUserFeeds = async (sources:string) => {
    const url = Urls('rssFeedsUrl',sources);
    let resp = await fetch(url).then((resp) => {

        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}

export const fetchSingleFeed = async (id: string) => {
    const url = Urls('singleFeedUrl', id);
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}
export const fetchAllFeeds = async () => {
    const url = Urls('allFeeds');
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}
export const fetchFeedsByTaxonomy = async (id: string) => {
    const url = Urls('byTaxonomyFeedsUrl', id);
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}

export const fetchFeedTaxonomy=async(id:string)=>{
    let Id="";
    if(id)Id=id;
    const url=Urls('feedTaxonomyUrl',Id);
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}

export default {}